export const supportedLocales = ["ar", "fr", "en"] as const;

export type AppLocale = (typeof supportedLocales)[number];

export type LocaleDirection = "rtl" | "ltr";

export const defaultLocale: AppLocale = "ar";

export const contentLocaleByAppLocale = {
  ar: "AR",
  fr: "FR",
  en: "EN",
} as const;

export const appLocaleByContentLocale = {
  AR: "ar",
  FR: "fr",
  EN: "en",
} as const;

export const isSupportedLocale = (locale: string): locale is AppLocale => {
  return supportedLocales.includes(locale as AppLocale);
};

export const normalizeLocale = (locale: string): AppLocale => {
  return isSupportedLocale(locale) ? locale : defaultLocale;
};

export const getLocaleDirection = (locale: AppLocale): LocaleDirection => {
  return locale === "ar" ? "rtl" : "ltr";
};
